@if (form.view) {
    @if (form.view) {
        <form #formRef="ngForm" (ngSubmit)="submit()" class="ms-1">
            <div class="d-flex flex-column flex-md-row">
                <div class="flex-grow-1">
                    <sf-form
                        name="form"
                        (ngModelChange)="onModelChange($event)"
                        [view]="getView(form.view)"
                        [(ngModel)]="form.model"
                        [fields]="['contact', 'requiresReferral']"
                    ></sf-form>
                </div>
                <button type="submit" class="btn btn-primary ms-auto" [disabled]="!isFormValid(formRef)">
                    @if (!form.saving && !isFormValid(formRef)) {
                        <i class="fa fa-circle-exclamation me-2 fa-fw"></i>
                    }
                    Add
                </button>
            </div>
        </form>
    }
} @else {
    @if (form.error) {
        <small class="text-danger">Error loading form</small>
    } @else {
        <small class="text-muted">Loading...</small>
    }
}
